import React, { CSSProperties, FC, ReactNode } from 'react'

import colorsJson from '../../colors.json'
import { InfoButton } from '../info-button'
import { InfoPopup } from '../info-popup'

const { colors } = colorsJson

export interface InfoModalProps {
  isOpen?: boolean
  onDialogClose: (e?: React.SyntheticEvent) => void
  onButtonClick?: (event: React.SyntheticEvent<HTMLDivElement>) => void
  body: ReactNode
  header: ReactNode
  customPopUpStyles?: CSSProperties
  iconSize?: number
  dataTestId?: string
}

export const InfoModal: FC<InfoModalProps> = ({
  isOpen = false,
  onDialogClose,
  onButtonClick,
  body,
  header,
  customPopUpStyles,
  iconSize,
  dataTestId,
}) => (
  <>
    <InfoButton
      color={colors['UI/White']}
      backgroundColor={colors['Brand/PrimaryGreen']}
      size={iconSize}
      onClick={onButtonClick}
      dataTestId={dataTestId}
    />
    <InfoPopup
      isOpen={isOpen}
      onClose={onDialogClose}
      body={body}
      header={header}
      customPopUpStyles={customPopUpStyles}
    />
  </>
)

export default InfoModal
